'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
# CaseMakerSVG
An SVG Case Maker icon
 */
var CaseMakerSVG = function CaseMakerSVG(_ref) {
  var color = _ref.color,
      height = _ref.height,
      width = _ref.width;
  return _react2.default.createElement(
    'svg',
    {
      'aria-label': 'Case Maker',
      role: 'img',
      height: height || undefined,
      width: width || undefined,
      viewBox: '0 0 75 75',
      xmlns: 'http://www.w3.org/2000/svg'
    },
    _react2.default.createElement(
      'g',
      {
        id: 'casemaker',
        fill: color,
        fillRule: 'nonzero'
      },
      _react2.default.createElement('path', {
        d: 'M16.7307692,0.721153846 L1.44230769,7.64423077 C0.288461538,8.22115385 -0.144230769,9.51923077 0.288461538,10.6730769 L7.21153846,25.8173077 C7.78846154,26.9711538 9.08653846,27.4038462 10.2403846,26.9711538 L25.3846154,20.0480769 C26.5384615,19.4711538 26.9711538,18.1730769 26.5384615,17.0192308 L19.6153846,1.875 C19.1826923,0.721153846 17.7403846,0.288461538 16.7307692,0.721153846 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M24.6634615,29.1346154 L8.07692308,29.1346154 C6.77884615,29.1346154 5.76923077,30.1442308 5.76923077,31.4423077 L5.76923077,48.1730769 C5.76923077,49.4711538 6.77884615,50.4807692 8.07692308,50.4807692 L24.8076923,50.4807692 C26.1057692,50.4807692 27.1153846,49.4711538 27.1153846,48.1730769 L27.1153846,31.2980769 C26.9711538,30.1442308 25.9615385,29.1346154 24.6634615,29.1346154 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M24.6634615,52.7884615 L8.07692308,52.7884615 C6.77884615,52.7884615 5.76923077,53.7980769 5.76923077,55.0961538 L5.76923077,71.8269231 C5.76923077,73.125 6.77884615,74.1346154 8.07692308,74.1346154 L24.8076923,74.1346154 C26.1057692,74.1346154 27.1153846,73.125 27.1153846,71.8269231 L27.1153846,55.0961538 C26.9711538,53.7980769 25.9615385,52.7884615 24.6634615,52.7884615 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M48.1730769,5.76923077 L31.5865385,5.76923077 C30.2884615,5.76923077 29.2788462,6.77884615 29.2788462,8.07692308 L29.2788462,24.8076923 C29.2788462,26.1057692 30.2884615,27.1153846 31.5865385,27.1153846 L48.3173077,27.1153846 C49.6153846,27.1153846 50.625,26.1057692 50.625,24.8076923 L50.625,8.07692308 C50.4807692,6.77884615 49.4711538,5.76923077 48.1730769,5.76923077 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M48.1730769,28.7019231 L31.5865385,28.7019231 C30.2884615,28.7019231 29.2788462,29.7115385 29.2788462,31.0096154 L29.2788462,47.5961538 C29.2788462,48.8942308 30.2884615,49.9038462 31.5865385,49.9038462 L48.3173077,49.9038462 C49.6153846,49.9038462 50.625,48.8942308 50.625,47.5961538 L50.625,31.0096154 C50.4807692,29.7115385 49.4711538,28.7019231 48.1730769,28.7019231 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M48.1730769,52.3557692 L31.5865385,52.3557692 C30.2884615,52.3557692 29.2788462,53.3653846 29.2788462,54.6634615 L29.2788462,71.3942308 C29.2788462,72.6923077 30.2884615,73.7019231 31.5865385,73.7019231 L48.3173077,73.7019231 C49.6153846,73.7019231 50.625,72.6923077 50.625,71.3942308 L50.625,54.6634615 C50.4807692,53.3653846 49.4711538,52.3557692 48.1730769,52.3557692 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M71.6826923,5.76923077 L55.0961538,5.76923077 C53.7980769,5.76923077 52.7884615,6.77884615 52.7884615,8.07692308 L52.7884615,24.8076923 C52.7884615,26.1057692 53.7980769,27.1153846 55.0961538,27.1153846 L71.8269231,27.1153846 C73.125,27.1153846 74.1346154,26.1057692 74.1346154,24.8076923 L74.1346154,8.07692308 C73.9903846,6.77884615 72.9807692,5.76923077 71.6826923,5.76923077 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M71.6826923,28.7019231 L55.0961538,28.7019231 C53.7980769,28.7019231 52.7884615,29.7115385 52.7884615,31.0096154 L52.7884615,47.5961538 C52.7884615,48.8942308 53.7980769,49.9038462 55.0961538,49.9038462 L71.8269231,49.9038462 C73.125,49.9038462 74.1346154,48.8942308 74.1346154,47.5961538 L74.1346154,31.0096154 C73.9903846,29.7115385 72.9807692,28.7019231 71.6826923,28.7019231 Z'
      }),
      _react2.default.createElement('path', {
        d: 'M71.6826923,52.3557692 L55.0961538,52.3557692 C53.7980769,52.3557692 52.7884615,53.3653846 52.7884615,54.6634615 L52.7884615,71.3942308 C52.7884615,72.6923077 53.7980769,73.7019231 55.0961538,73.7019231 L71.8269231,73.7019231 C73.125,73.7019231 74.1346154,72.6923077 74.1346154,71.3942308 L74.1346154,54.6634615 C73.9903846,53.3653846 72.9807692,52.3557692 71.6826923,52.3557692 Z'
      })
    )
  );
};

CaseMakerSVG.propTypes = {
  /** a color for the icon */
  color: _propTypes2.default.string,
  /** height for the SVG. Can be px, rem, percentage, etc. */
  height: _propTypes2.default.string,
  /** width for the SVG. Can be px, rem, percentage, etc. */
  width: _propTypes2.default.string
};

CaseMakerSVG.defaultProps = {
  color: undefined,
  height: undefined,
  width: undefined
};

CaseMakerSVG.displayName = 'CaseMakerSVG';

exports.default = CaseMakerSVG;
CaseMakerSVG.__docgenInfo = {
  'description': '# CaseMakerSVG\r\nAn SVG Case Maker icon',
  'methods': [],
  'displayName': 'CaseMakerSVG',
  'props': {
    'color': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'a color for the icon'
    },
    'height': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'height for the SVG. Can be px, rem, percentage, etc.'
    },
    'width': {
      'defaultValue': {
        'value': 'undefined',
        'computed': true
      },
      'type': {
        'name': 'string'
      },
      'required': false,
      'description': 'width for the SVG. Can be px, rem, percentage, etc.'
    }
  }
};